export const VIEW = { HIDDEN: 'hidden', BANNER: 'banner', MANAGE: 'manage' };

// The upfront banner only appears where consent is required before tracking:
// the opt-in states (CA/FL/PA/IL), international, and unknown-region visitors.
// In opt-out states tracking runs by default, so we show no banner — the
// "Your Privacy Choices" footer link opens the settings/opt-out center on
// demand. An explicit prior decision hides the banner in every case.
export function restingViewFor({ decided, posture }) {
  const promptsForConsent = !decided && posture !== 'opt_out';
  return promptsForConsent ? VIEW.BANNER : VIEW.HIDDEN;
}
